import type { Handleiding } from './soort';

export const fr: Handleiding = {
  code: 'fr',
  titel: 'Mode d’emploi',
  inleiding:
    'Ask Gio Tolk traduit une conversation entre deux personnes qui ne parlent pas la même langue. Voici ce que fait chaque bouton.',
  knop: 'Ouvrir le mode d’emploi',
  sluiten: 'Fermer',
  groepGebruik: 'Participer',
  groepBeheer: 'Régler et gérer',
  delen: [
    {
      titel: 'Parler',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Parle',
          uitleg:
            'Touche une fois pour commencer. L’enregistrement s’arrête tout seul dès que tu te tais pendant une bonne seconde, ou si tu touches encore une fois. Au bout d’une minute il s’arrête de toute façon.',
        },
        {
          kop: 'Un seul son à la fois',
          uitleg:
            'Tant que l’app parle, tu ne peux pas enregistrer. Et tant que tu enregistres, une traduction qui arrive attend que tu aies fini. Sinon ton micro enregistre l’app et croit que c’est toi qui l’as dit.',
        },
        {
          kop: 'Tape ton message ici',
          uitleg:
            'Fonctionne à côté de la parole et passe par la même traduction. Entrée envoie, majuscule et entrée fait une nouvelle ligne.',
        },
        {
          kop: 'Temps pour corriger',
          uitleg:
            'Règle ici le nombre de secondes dont tu disposes pour relire ta phrase transcrite avant qu’elle parte. À zéro, elle part tout de suite.',
        },
        {
          kop: 'Toujours relire et envoyer soi-même',
          uitleg:
            'Plus d’horloge. Chaque phrase attend que tu appuies sur envoyer. Pour qui veut relire chaque phrase.',
        },
        {
          kop: 'Lire la traduction tout de suite',
          uitleg:
            'Activé. Désactive-le si tu préfères lire d’abord et décider toi-même quand tu écoutes.',
        },
      ],
    },
    {
      titel: 'Lire les messages',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Ce qui est en grand',
          uitleg:
            'Ce qui est dans TA langue est en grand. Pour ta propre phrase, c’est ton texte d’origine, pour que tu puisses vérifier si l’app t’a bien compris. Pour une phrase de l’autre, c’est la traduction.',
        },
        {
          kop: 'Déplier l’original ou la traduction',
          uitleg: 'L’autre langue est en dessous, repliée. Touche la ligne pour l’ouvrir.',
        },
        {
          kop: 'Le petit triangle',
          uitleg: 'Rejoue la traduction.',
        },
        {
          kop: 'La tête qui parle',
          uitleg:
            'Joue l’enregistrement de l’autre personne. N’apparaît que sur un message PARLÉ et seulement si « envoie aussi ta propre voix » est activé. Un message tapé n’a pas d’enregistrement.',
        },
      ],
    },
    {
      titel: 'Boutons en haut de l’écran',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Moins et plus',
          uitleg: 'Rend le texte plus petit ou plus grand. En cinq étapes, et ça reste enregistré.',
        },
        {
          kop: 'Le micro',
          uitleg: 'Cache le bouton de parole si tu ne fais que taper. Ça gagne de la place.',
        },
        {
          kop: 'Le clavier',
          uitleg:
            'Cache la zone de texte. Il en reste toujours un des deux, sinon tu ne peux plus rien dire.',
        },
      ],
    },
    {
      titel: 'Arriver',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Quelle langue parles-tu',
          uitleg:
            'Ce choix détermine aussi la langue des boutons et des messages. Vous voyez donc chacun un écran différent, et c’est voulu.',
        },
        {
          kop: 'Ta voix dans la traduction',
          uitleg:
            'Choisis si tu sonnes comme un homme ou une femme. Cela t’appartient à TOI, pas à la salle : chaque participant choisit séparément.',
        },
        {
          kop: 'Autorisation pour le micro',
          uitleg:
            'Le navigateur la demande à l’entrée. Si tu dis non, tu peux encore taper. Tu peux donner l’autorisation plus tard via le cadenas dans la barre d’adresse.',
        },
      ],
    },
    {
      titel: 'En bas, replié',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Liste de mots de secours',
          uitleg:
            'Des mots qui doivent toujours être traduits de la même façon : noms, termes techniques, marques. Vaut pour toute la salle.',
        },
        {
          kop: 'Modifier les réglages',
          uitleg:
            'La langue, la voix, le ton et la correction orthographique se changent aussi EN PLEINE conversation. Ce que tu changes ici vaut tout de suite pour vous deux.',
        },
      ],
    },
    {
      titel: 'Commencer une conversation',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'Nom de la conversation',
          uitleg:
            'Peut rester vide. Il n’apparaît qu’en haut de ton écran, pour que tu saches avec qui tu parles.',
        },
        {
          kop: 'Locuteur 1 et locuteur 2',
          uitleg:
            'Les deux langues de cette conversation. Celui qui arrive en premier prend la première place. Tu peux encore échanger les langues plus tard.',
        },
        {
          kop: 'Ton de la traduction',
          uitleg:
            'À gauche tu choisis le tutoiement ou le vouvoiement, à droite l’ambiance : neutre, amicale, professionnelle, officielle ou partenaire. Sans consigne, le modèle choisit presque toujours la forme formelle, et dans une conversation ordinaire cela sonne distant.',
        },
        {
          kop: 'Envoie aussi ta propre voix',
          uitleg:
            'L’autre peut entendre ton propre enregistrement à côté de la traduction. Pratique pour apprendre une langue. Désactive-le pour une conversation sensible : celui qui reçoit l’enregistrement peut le garder.',
        },
        {
          kop: 'Corrige les fautes dans ton propre texte',
          uitleg:
            'Activé. Désactive-le pour voir ce que le modèle a vraiment compris. S’il y a alors une phrase bizarre, tu sais si elle a été mal comprise ou bien comprise puis lissée.',
        },
        {
          kop: 'Avec code PIN',
          uitleg:
            'Transmets le code de vive voix, pas dans le même message que le lien. Cela protège contre un lien transféré.',
        },
        {
          kop: 'Le code QR',
          uitleg:
            'Fais-le scanner par l’autre, ou envoie le lien. Une salle expire d’elle-même après quatre heures.',
        },
      ],
    },
    {
      titel: 'Ce qui arrive à ta conversation',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'Le texte n’est pas conservé',
          uitleg:
            'Ce que vous dites n’entre pas dans la base de données. Seulement quand et combien on a parlé, pour les coûts.',
        },
        {
          kop: 'Les enregistrements disparaissent tout seuls',
          uitleg: 'L’audio reste dix minutes en mémoire puis s’en va.',
        },
        {
          kop: 'La salle expire',
          uitleg: 'Quatre heures après sa création. Ensuite le lien ne marche plus.',
        },
        {
          kop: 'Il y a un budget',
          uitleg:
            'Par salle et par mois. S’il est épuisé, l’app arrête de traduire et le dit. Ce n’est pas une panne.',
        },
      ],
    },
  ],
};
